import EmailsSetup from './EmailsSetup';

export default EmailsSetup;
